export default __webpack_public_path__ + "static/media/SMS.96299806.svg";